export const UNSUPPORTED_GROUPED_HEADER_MESSAGE =
  'Grouped headers cannot span pinned and unpinned columns in SharedVirtualTable.'

export const STYLES = {
  emptyStateContainer:
    'tw:flex tw:h-full tw:min-h-[200px] tw:w-full tw:items-center tw:justify-center tw:border tw:border-solid tw:border-md3-outline-variant tw:bg-md3-surface tw:px-6 tw:py-8',
  emptyStateContent:
    'tw:sticky tw:left-0 tw:flex tw:min-h-[200px] tw:items-center tw:justify-center tw:px-6 tw:py-8',
  emptyStateText: 'tw:text-body-md tw:text-md3-on-surface-variant',
  gridContainer:
    'tw:flex tw:h-full tw:flex-col tw:overflow-auto tw:bg-md3-surface tw:[&_*]:tw:box-border',
  innerTable: 'tw:relative tw:min-w-full',
  headerRowGroup:
    'tw:sticky tw:top-0 tw:z-[5] tw:bg-md3-surface tw:border-0 tw:border-b-[1px] tw:border-solid tw:border-md3-surface-dim',
  headerRow: 'tw:flex tw:w-full',
  headerCell:
    'tw:relative tw:flex tw:bg-md3-surface tw:border-0 tw:border-r-[1px] tw:border-solid tw:border-md3-surface-dim tw:px-2 tw:text-label-lg tw:text-md3-on-surface-variant tw:outline-none tw:transition-colors tw:duration-150 tw:hover:bg-md3-surface-container-low',
  sortableHeaderContent:
    'tw:flex tw:h-full tw:min-h-[28px] tw:w-full tw:items-center tw:gap-2 tw:border-0 tw:bg-transparent tw:p-0 tw:text-inherit tw:shadow-none tw:appearance-none tw:rounded-none tw:outline-none',
  staticHeaderContent:
    'tw:flex tw:h-full tw:min-h-[28px] tw:w-full tw:items-center tw:overflow-hidden',
  headerSortIcon: 'tw:flex tw:items-center tw:text-inherit',
  resizeHandle:
    'tw:absolute tw:top-0 tw:z-[1] tw:flex tw:h-full tw:cursor-col-resize tw:items-center tw:justify-center tw:outline-none tw:transition-colors tw:duration-150 tw:hover:bg-md3-primary/10 tw:focus-visible:bg-md3-primary/10',
  resizeHandleLine:
    'tw:h-full tw:w-[2px] tw:rounded-full tw:bg-transparent tw:transition-colors tw:duration-150 tw:group-hover:bg-md3-primary/25 tw:group-focus-visible:bg-md3-primary/25',
  resizeHandleLineActive: 'tw:bg-md3-primary',
  bodyRow: 'tw:absolute tw:left-0 tw:flex tw:w-full tw:bg-md3-surface tw:group',
  bodyRowClickable: 'tw:cursor-pointer',
  bodyCell:
    'tw:relative tw:flex tw:min-w-0 tw:items-center tw:overflow-hidden tw:bg-md3-surface tw:border-0 tw:border-b-[1px] tw:border-r-[1px] tw:border-solid tw:border-md3-surface-dim tw:px-3 tw:text-body-md tw:text-md3-on-surface tw:outline-none tw:group-hover:bg-md3-primary-opacity-08',
  bodyCellPinned:
    'tw:group-hover:bg-md3-surface tw:before:absolute tw:before:inset-0 tw:before:pointer-events-none tw:group-hover:before:bg-md3-primary-opacity-08',
} as const
